import { ApiRequest } from 'services/ApiRequest';
import { CLOUD_RECIPIENTS_URL } from 'appConstants';
import { CloudRecipientUser, CloudRecipientsResponse } from 'types';
import { Recipient } from 'types';

const mapCloudRecipientUserToRecipient = (
  user: CloudRecipientUser,
): Recipient => ({
  id: user.id,
  email: user.email,
  username: user.username,
  fullName: user.username,
  roles: ['Ticket Reviewer'],
  _isCloudTicketReviewer: true,
  _isChecked: true,
  _isCreator: false,
  _isPrimary: false,
  _toRemove: false,
});

const mapCloudRecipientsToRecipients = (
  response: CloudRecipientsResponse,
): Recipient[] => {
  const usersFromUsers = (response.users || []).map(
    mapCloudRecipientUserToRecipient,
  );

  const usersFromGroups = (response.userGroups || []).reduce<Recipient[]>(
    (acc, group) =>
      group.members
        ? acc.concat(group.members.map(mapCloudRecipientUserToRecipient))
        : acc,
    [],
  );

  return [...usersFromUsers, ...usersFromGroups];
};

const fetchCloudRecipients = async (
  accountId: string,
  domainId: string,
): Promise<Recipient[]> => {
  try {
    const response = await ApiRequest.get(
      `${CLOUD_RECIPIENTS_URL}?accountID=${accountId}&domainID=${domainId}`,
    );

    if (ApiRequest.isError(response)) {
      return [];
    }

    return mapCloudRecipientsToRecipients(response as CloudRecipientsResponse);
  } catch {
    return [];
  }
};

export { fetchCloudRecipients, mapCloudRecipientsToRecipients };
